import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { Container, Grid, makeStyles, Popover, Typography } from '@material-ui/core';
import Hello from './img-greeting.svg';
import { useState } from 'react';
import ModalReCaptcha from '../../recaptcha/ModalReCaptcha';
import { PrimaryButton } from '../../common/PrimaryButton';
import { login } from '../../AppStateProvider/authentification/authentification';
import useGetHistoryResults from '../Results/HistoryResults/useGetHistoryResults';

var counter: number = 0;
export function GetStarted() {
  const useStyles = makeStyles({
    smallIllustrationContainer: {
      '@media screen and (max-width: 760px)': {
        display: 'flex',
        justifyContent: 'center',
      },
      '@media screen and (min-width: 761px)': {
        display: 'none',
      },
    },
    illustrationContainer: {
      '@media screen and (max-width: 760px)': {
        display: 'none',
      },
    },
    image: {
      marginTop: '12px',
      width: '60vw',
      height: 'auto',
      maxWidth: '100%',
      '@media screen and (max-width: 374px)': {
        height: '187px',
      },
      '@media screen and (min-width: 375px) and (max-width: 540px)': {
        height: '250px',
      },
      '@media screen and (min-width: 541px) and (max-width: 1024px)': {
        height: '360px',
      },
    },
    gridItem: {
      marginTop: '35px',
      display: 'flex',
      '@media screen and (max-width: 950px) and (min-width: 761px)': {
        marginTop: '35px',
        marginRight: '40px',
      },
    },
    typographyBody1: {
      marginBottom: '35px',
      opacity: '50%',
      '@media screen and (max-width: 950px)': {
        marginTop: '15px',
      },
    },
    gridContainer: {
      justifyContent: 'space-between',
      '@media screen and (max-width: 950px) and (min-width: 761px)': {
        display: 'flex',
        flexWrap: 'nowrap',
      },
    },
  });
  const { nextPane } = useAppStateContext();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [verified, setVerified] = useState(false);
  const { dispatch } = useAppStateContext();
  const classes = useStyles();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setVerified(true);
    nextPane();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const { fetchHistoryResults } = useGetHistoryResults(dispatch);

  if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' && counter < 1) {
    fetchHistoryResults();
    counter++;
  }

  return (
    <Container>
      <Grid container className={classes.gridContainer}>
        <Grid item md={5} className={classes.gridItem} direction="column" justifyContent="space-between">
          <div>
            <Typography variant="h1" style={{ marginBottom: '12px' }}>
              Let's get started!
            </Typography>

            <Typography variant="body1" style={{ marginBottom: '30px', display: 'flex', fontSize: '17px' }}>
              We'll help you solve any video troubles you're experiencing but first, let's check your setup.
            </Typography>
            <PrimaryButton onClick={verified ? nextPane : handleClick}>Get started</PrimaryButton>
          </div>
          <Grid item md={5} className={classes.smallIllustrationContainer}>
            <img src={Hello} alt="Hello" className={classes.image} />
          </Grid>
          <Grid>
            {localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined' ? (
              <Typography variant="body1" className={classes.typographyBody1} style={{ marginBottom: '15px' }}>
                To make your communication with our support service more efficient please
                <button
                  style={{ color: 'rgb(0, 149, 255)', fontWeight: 'bold', textDecorationLine: 'underline' }}
                  onClick={login}
                >
                  {' '}
                  log in{' '}
                </button>
                to your account.
              </Typography>
            ) : null}
            <Typography variant="body1" className={classes.typographyBody1}>
              Not sure about something? Skip that section for now, and your support administrator can help later.
            </Typography>
          </Grid>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            {<ModalReCaptcha onValid={handleClose} />}
          </Popover>
        </Grid>

        <Grid item md={5} className={classes.illustrationContainer}>
          <img src={Hello} alt="Hello" className={classes.image} />
        </Grid>
      </Grid>
    </Container>
  );
}
